const isDevelopment = import.meta.env.DEV;

interface LogContext {
  [key: string]: unknown;
}
export const logger = {
  error: (error: Error | unknown, context?: LogContext) => {
    if (isDevelopment) {
      console.error('Error:', error);
      if (context) {
        console.error('Context:', context);
      }
    }
  },

  warn: (message: string, context?: LogContext) => {
    if (isDevelopment) {
      console.warn('Warning:', message);
      if (context) {
        console.warn('Context:', context);
      }
    }
  },

  info: (message: string, context?: LogContext) => {
    if (isDevelopment) {
      console.info('Info:', message);
      if (context) {
        console.info('Context:', context);
      }
    }
  },
};
